import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FactoryComponent } from "./factory.component";


const routes: Routes = [
  {
    path: 'factory',
    component: FactoryComponent,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FactoryRoutingModule { }
